import { bsModal } from "./plugins";

$(".pdf-modal").on("click", function (e) {
  e.preventDefault();
  const button = $(e.target);

  const infoModal = bsModal("full", {
    title: button.data("title"),
    closeOtherModals: true,
    keyboard: true,
    backdrop: true,
    modalId: "pdf-modal",
  });

  const iframe = `<iframe src="${$(this).attr(
    "href",
  )}" class="full-screen-iframe" width="100%" height="100%"></iframe>`;

  $(infoModal).modal("content", iframe);
});

export const openIframePopup = (popupTitle, iframeUrl) => {
  const popupTemplate = `
    <div class="ms-iframe-popup-inner" style="display:none;">
      <div class="ms-iframe-popup-header">
        <img class="ms-iframe-popup-logo" src="/static/images/logo_2_iframe.png" alt="Mega Insurance OJSC">
        <h2 class="ms-iframe-popup-title">Travel Insurance</h2>
        <button class="ms-iframe-popup-close">×</button>
      </div>
      <div class="ms-iframe-popup-loading-wr">
        <div class="ms-iframe-popup-loading">
          <div></div><div></div><div></div><div></div>
        </div>
      </div>
      <iframe class="ms-iframe-popup-iframe"></iframe>
    </div>
  `;
  const iframePopup = document.querySelector(".ms-iframe-popup");

  // If the popup is not created yet, create it
  if (iframePopup === null) {
    const popup = document.createElement("div");
    popup.classList.add("ms-iframe-popup");
    popup.innerHTML = popupTemplate;
    document.body.appendChild(popup);
  } else {
    if (
      document.querySelector(".ms-iframe-popup-iframe") &&
      document.querySelector(".ms-iframe-popup-iframe").src === iframeUrl
    ) {
      // If the popup is already created, show it
      iframePopup.classList.add("ms-iframe-popup-show");
      return;
    }
  }

  const iframe = document.querySelector(".ms-iframe-popup-iframe");

  // By default, the popup is hidden
  document.querySelector(".ms-iframe-popup-inner").style.display = "block";

  iframe.src = null;
  document.querySelector(".ms-iframe-popup-loading-wr").style.display = "flex";

  // Set the iframe URL. The iframe will be loaded after the popup is shown
  iframe.src = iframeUrl;
  iframe.onload = () => {
    document.querySelector(".ms-iframe-popup-loading-wr").style.display =
      "none";
  };

  // Set the popup title
  document.querySelector(".ms-iframe-popup-title").innerText = popupTitle;

  // Wait for the iframe to load
  setTimeout(() => {
    document
      .querySelector(".ms-iframe-popup")
      .classList.add("ms-iframe-popup-show");
  }, 100);

  // Close the popup when the close button is clicked
  document
    .querySelector(".ms-iframe-popup-close")
    .addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      document
        .querySelector(".ms-iframe-popup")
        .classList.remove("ms-iframe-popup-show");
    });
};
